import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-chevrolet',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Chevrolet icon</title><path d="M23.905 9.784H15.92V8.246a.157.157 0 00-.157-.158H8.238a.157.157 0 00-.157.158v1.538H2.358c-.087 0-.193.07-.237.158L.02 14.058c-.045.088-.011.157.077.157H8.08v1.54c0 .086.07.157.157.157h7.525c.087 0 .157-.07.157-.157v-1.54h5.723c.087 0 .193-.07.238-.157l2.1-4.116c.045-.087.011-.158-.076-.158m-2.494.996l-1.244 2.437h-5.232v1.708H9.07v-1.708H2.595L3.84 10.78h5.232V9.073h5.864v1.707z"/></svg>`,
    styles: []
})
export class SimpleIconsChevroletComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#CD9834';
    @Input() className: string = 'simple-icons-chevrolet'
    constructor() {}
    ngOnInit(): void {}
}
